import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileLaborContract } from "core/http/service/operationProcess/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: FileLaborContract | null;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: null,
};

const getFileLaborContractSlice = createSlice({
  name: "getFileLaborContract",
  initialState,
  reducers: {
    getFileLaborContractStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getFileLaborContractSuccess: (
      state,
      action: PayloadAction<FileLaborContract>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getFileLaborContractFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetFileLaborContract: () => {
      return { ...initialState };
    },
  },
});

export const {
  getFileLaborContractStart,
  getFileLaborContractSuccess,
  getFileLaborContractFailed,
  resetFileLaborContract,
} = getFileLaborContractSlice.actions;

export default getFileLaborContractSlice.reducer;
